module.exports = __webpack_public_path__ + "static/media/relaystream-logo-mini.b809f68a.png";


//////////////////
// WEBPACK FOOTER
// ./src/relaystream-logo-mini.png
// module id = 758
// module chunks = 0